import React from 'react';
import { IonButton, IonFooter, IonToolbar } from '@ionic/react';
import { useTranslation } from 'react-i18next';

interface FooterActionsProps {
  onSave: () => void;
  onClose: () => void;
  isSaving: boolean;
}

const FooterActions: React.FC<FooterActionsProps> = ({ onSave, onClose, isSaving }) => {
  const { t } = useTranslation();

  return (
    <IonFooter>
      <IonToolbar>
        <div className="hidden ion-padding footer-buttons">
          <IonButton
            fill="outline"
            onClick={onClose}
            disabled={isSaving}
          >
            {t('common.cancel')}
          </IonButton>
          <IonButton
            onClick={onSave}
            disabled={isSaving}
          >
            {isSaving ? t('common.saving') : t('common.save')}
          </IonButton>
        </div>
      </IonToolbar>
    </IonFooter>
  );
};

export default FooterActions;
